module.exports = __webpack_public_path__ + "8274e674.svg";